import React, { Component } from 'react';
class ResetPasswordForm extends Component {
  constructor() {
    super();
    this.state = { 
    };
  } 

  componentDidMount() {
   this.create_captcha_code();
  }


  create_captcha_code(){
    var font_name = 'Arial';
    var captcha_color = 'red';
    document.getElementById('login_captcha_code').innerHTML = "";
       var captcha = 'hg24Ds';
       var canv = document.createElement("canvas");
       canv.id = "login_captcha_code_div";
       canv.width = 100;
       canv.height = 50;
       var ctx = canv.getContext("2d");
       ctx.font = font_name;
       ctx.font = '20px Verdana';
       ctx.strokeStyle = captcha_color;
       ctx.strokeText(captcha, 0, 30);
       document.getElementById("login_captcha_code").appendChild(canv); // adds the canvas to the body element

  }

  render() {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <h1 className="text-center wow fadeInUp" data-wow-delay="0.1s">Reset Password</h1>
                <div className="row g-4">
                     
                 <div className="col-md-4"></div>
                     
                    <div className="col-md-4">
                        <div className="wow fadeInUp" data-wow-delay="0.5s">
                            <p className="mb-4"></p>
                            <form action="" method="post">
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="name" placeholder="Your Name"/>
                                            <label for="name">Email</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" id="email" placeholder="Your Email"/>
                                            <label for="email">Password</label>
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <div className="form-floating">
                                            <p className="code-pm-zero">Code</p>
                                            <span id="login_captcha_code"></span>
                                        </div>
                                    </div> 
                                    <div className="col-7">
                                        <div className="form-floating">
                                            <span><i class="fa fa-2x fa fa-retweet text-primary reload-icon"></i></span>
                                        </div>
                                    </div> 
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="subject" placeholder="Enter Code"/>
                                            <label for="subject">Enter Code</label>
                                        </div>
                                    </div>                                    
                                    <div className="col-md-12">
                                        <button className="btn btn-primary w-100 py-3" type="button">Login</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-md-4"></div>

                </div>
            </div>
        </div>
    );
  }
}

export default ResetPasswordForm;
